<template>
  <expandable header="ABG Test">
    <div v-for="i in 4" :key="i" class="mb-3 border-bottom pb-3">
      <div class="h6 px-2 mb-2">ABG Test {{ i }}</div>
      <b-row class="px-md-4">
        <b-col cols="12" md="2" class="pb-2">
          <file-input-group
            v-model="form[`ABG_file_upload_${i}`]"
            @input="onInput"
            :label="'File ' + i"
            accept=".jpg,capture=camera,.jpeg,.png,.pdf"
            :disabled="isDisabled"
            :rules="i <= 2 ? 'required|file-image-pdf|file-size' : 'file-image-pdf|file-size'"
          ></file-input-group>
        </b-col>
        <b-col cols="6" md="2" class="pb-2">
          <input-group
            :prepend="i == 1 ? '100%' : ''"
            :label="`FiO<sub>2</sub>`"
            v-model="form[`FIO2_${i}`]"
          ></input-group>
        </b-col>
        <b-col cols="6" md="2" class="pb-2">
          <input-field
            v-model="form[`abg_ph_${i}`]"
            label="pH"
            :disabled="isDisabled"
            @input="onInput"
          ></input-field>
        </b-col>
        <b-col cols="6" md="2" class="pb-2">
          <input-field
            v-model="form[`abg_paco2_${i}`]"
            label="PaCO2"
            :disabled="isDisabled"
            @input="onInput"
          ></input-field>
        </b-col>
        <b-col cols="6" md="2" class="pb-2">
          <input-field
            v-model="form[`abg_pao2_${i}`]"
            label="PaO2"
            :disabled="isDisabled"
            @input="onInput"
          ></input-field>
        </b-col>
        <b-col cols="6" md="2" class="pb-2">
          <input-field
            v-model="form[`abg_hco3_${i}`]"
            label="HCO3"
            :disabled="isDisabled"
            @input="onInput"
          ></input-field>
        </b-col>
      </b-row>
    </div>
  </expandable>
</template>

<script>
import Expandable from "../../Expandable.vue";
import FileInputGroup from "../../form/FileInputGroup.vue";
import InputGroup from "../../form/InputGroup.vue";
export default {
  components: { Expandable, FileInputGroup, InputGroup },
  props: {
    value: {},
    isDisabled: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      form: {},
    };
  },
  methods: {
    onInput() {
      this.$emit("input", this.form);
      console.log(this.form);
    },
    formattedLabel(label, rules) {
      if (!rules) return label;
      if (rules.indexOf("required") != -1)
        return label + " <span style='color:red'>*</span>";
      return label;
    },
  },
  beforeMount() {
    this.form = this.value;
    // if(!this.form['FIO2_1'])  this.form['FIO2_1'] = "100%"
  },
};
</script>

<style></style>
